import {
  Button,
  ButtonsWrapper,
  Form,
  ICONS,
  PLATFORM_THEME_COLORS,
  DeleteModal,
  TextInput,
} from '@thinknet-gmbh/platform-common-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useHolidayNavigate } from 'src/pages/settings/components/holiday-manager/holiday-manager.hook';

import { MainContainer } from './location-edit.styles';

const LocationEdit = ({
  data,
  onFinish,
  onDelete,
}: {
  data: any;
  onFinish: (values: any) => void;
  onDelete: () => void;
}) => {
  const { t } = useTranslation(['common', 'settings']);
  const [isOpenedDeleteModal, setIsOpenedDeleteModal] = useState(false);
  const { pageNavigate } = useHolidayNavigate();

  const closeDeleteModal = () => {
    setIsOpenedDeleteModal(false);
  };

  const onDeleteSubmit = () => {
    onDelete();
    closeDeleteModal();
    pageNavigate();
  };

  const onFormSubmit = (values: any) => {
    onFinish(values);
    pageNavigate();
  };

  return (
    <MainContainer>
      <DeleteModal
        isOpened={isOpenedDeleteModal}
        onClose={closeDeleteModal}
        title={t('settings:holidayManager.deleteLocation.title')}
        subTitle={t('settings:holidayManager.deleteLocation.subtitle')}
        helperText={t('settings:holidayManager.deleteLocation.contentText')}
        onSubmit={onDeleteSubmit}
        translate={t}
      />
      <Form layout="vertical" onFinish={onFormSubmit} initialValues={data}>
        <Form.Item
          name="name"
          label={t('settings:holidayManager.labels.locationName')}
          rules={[{ required: true, message: t('common:validation.error.locationRequired') }]}
        >
          <TextInput />
        </Form.Item>
        <ButtonsWrapper>
          <Button htmlType="submit" type="primary">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={() => pageNavigate()}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
      <Button
        danger
        icon={ICONS.trash}
        iconColor={PLATFORM_THEME_COLORS.tone.red}
        onClick={() => setIsOpenedDeleteModal(true)}
      >
        {t('common:buttons.delete')}
      </Button>
    </MainContainer>
  );
};

export default LocationEdit;
